import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "../../components/ScrollToTop";
import { LocaleContextProvider } from "../../hooks/locale";
import { useSite } from "../../hooks/site";
import { updateSiteLocaleId } from "../../utils/SiteUtils";
import Navbar from "../redesign/navbar/Navbar";
import { LegacyToWebflowRedirect } from "./Redirect";
import { WithTracking } from "./WithTracking";
import { isSupportedLocaleId, localeByLocaleId } from "./localeByLocaleId";

const AppLayout = ({ useLocaleId = true }) => {
	const { supportedLocaleIds, defaultLocaleId } = useSite();
	const { localeId } = useParams();
	const { auth, loading } = useSelector((state) => state);
	const navigate = useNavigate();

	const defaultLocale = localeByLocaleId[defaultLocaleId];
	if (useLocaleId && localeId === defaultLocaleId) {
		return (
			<LocaleContextProvider value={defaultLocale}>
				<LegacyToWebflowRedirect to="" />
			</LocaleContextProvider>
		);
	}
	if (useLocaleId && !isSupportedLocaleId(localeId)) {
		return (
			<LocaleContextProvider value={defaultLocale}>
				<LegacyToWebflowRedirect to="" />
			</LocaleContextProvider>
		);
	}

	let resolvedLocale = defaultLocale;
	if (isSupportedLocaleId(localeId)) {
		resolvedLocale = localeByLocaleId[localeId];
	}

	useEffect(() => {
		updateSiteLocaleId();
	}, []);

	return (
		<LocaleContextProvider value={resolvedLocale}>
			<Navbar auth={auth}>
				<WithTracking>
					<div className="PLT">
						<style>{`
                            body {
                                background-color: #effaff;
                            }
                        `}</style>
						<div className={"Content"}>
							<ToastContainer position="top-center" hideProgressBar />
							<ScrollToTop>
								<Outlet />
							</ScrollToTop>
						</div>
						{loading.status && (
							<div className="loading">
								<FontAwesomeIcon
									spin
									style={{ fontSize: "30px" }}
									icon={faSpinner}
								/>
							</div>
						)}
					</div>
				</WithTracking>
			</Navbar>
		</LocaleContextProvider>
	);
};

export default AppLayout;
